export const chartColors =
    process.env.NEXT_PUBLIC_VARIANT === "cada" || window.location.hostname.includes("cada")
        ? ["#B61D22", "#1A6E8F", "#8A8D8F", "#F3A73B"]
        : ["#A3302F", "#365F90", "#BFBFBF", "#F3A73B"];

export const chartColorsDark =
    process.env.NEXT_PUBLIC_VARIANT === "cada" || window.location.hostname.includes("cada")
        ? ["#9e181ce6", "#165a75e6", "#595C63", "#F3A73BE6"]
        : ["#912b29e6", "#305481e6", "#afafafe6", "#e49c37e6"];
